export interface AdSlot {
    format: AdFormat
    shape: AdShape
    size: AdSize
    layout: AdLayout
    slot: number
}

export type AdFormat = 'auto' | 'autorelaxed' | 'fluid' | string
export type AdSize = "small" | "medium" | "large" | "" | null | undefined
export type AdShape = "square" | "rectangle" | "leaderboard" | "half-page" | string
export type AdLayout = "in-article" | "" | string

export function NewSlot(config: { format?: AdFormat, shape?: AdShape, size?: AdSize, layout?: AdLayout, number: number }): AdSlot {
    return {
        format: config.format || 'auto',
        shape: config.shape || 'rectangle',
        size: config.size || '',
        layout: config.layout || '',
        slot: config.number
    }
}

export const AdsenseConfiguration = (): { refreshInterval: number, slots: { [key: string]: AdSlot }, captcha: { siteKey: string } } => ({
    refreshInterval: 60000,
    slots: {
        home_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'auto', number: 5298209007 }), /*th-home-leaderboard-slot-1*/
        home_slot2: NewSlot({ shape: 'leaderboard', size: 'large', format: 'auto', number: 9966778338 }), /*th-home-multiplex-slot-2*/
        sidebar_slot1: NewSlot({ shape: 'rectangle', size: 'medium', format: 'auto', number: 2594000529 }), /*th-sidebar-slot-1*/
        sidebar_slot2: NewSlot({ shape: 'half-page', size: 'medium', format: 'auto', number: 2863617358 }), /*th-sidebar-slot-2*/
        tablature_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'auto', number: 5845068913 }), /*th-tablature-slot-1*/
        tablatures_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'autorelaxed', number: 2494416848 }), /*th-tablatures-slot-1*/
        forum_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'auto', number: 9020204774 }), /*th-forums-slot-1*/
        topic_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'auto', number: 4342593162 }), /*th-topics-slot1*/
        pages_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'autorelaxed', number: 8292254492 }), /*th-pages-slot1*/
        posts_slot1: NewSlot({ shape: 'leaderboard', size: 'large', format: 'fluid', layout: 'in-article', number: 9501528304 }), /*th-posts-slot-1*/
    },
    captcha: {
        siteKey: '6Lcd_6wUAAAAAGWzLn9J-serb3SZmqK0l-A9hI0q',
    }
})